import React from 'react';
import { FaQuoteLeft } from 'react-icons/fa'; // Icon for a professional touch
import './HomeMessage.css';

import principal from '../../../assets/Principal.jpg';
import secretary from '../../../assets/boy.jpg'
function HomeMessage() {
  const messages = [
    {
      id: 1,
      title: "Message from the Secretary",
      text: "At SK TT College, we are proud to have specially-abled faculty members who serve as an inspiration to our students. Our disabled faculty teach and mentor disabled students, creating an inclusive environment where everyone can excel. This unique approach not only empowers our faculty but also provides role models for students facing similar challenges, proving that determination knows no boundaries.",
      name: "Bhairoon Singh Bhati",
      role: "Secretary, S.K.T.T. College",
      image: secretary
    }
  ];

  return (
    <section className="home-message-section">
      <div className="home-message-container">
        <div className="home-message-header">
          <h2 className="home-message-section-title">Words from Our Leadership</h2>
        </div>

        <div className="home-message-layout-grid">
          {messages.map((item) => (
            <article key={item.id} className="home-message-card">
              
              {/* === Image Container with Themed Frame === */}
              <div className="home-message-image-container">
                <div className="home-message-image-frame">
                   <img src={item.image} alt={item.name} className="home-message-photo" />
                </div>
              </div>

              {/* === Content Container with Quote === */}
              <div className="home-message-content-container">
                <FaQuoteLeft className="home-message-bg-icon" />
                <h3 className="home-message-item-title">{item.title}</h3>
                <p className="home-message-text">{item.text}</p>
                <div className="home-message-signature">
                  <h4 className="home-message-name">{item.name}</h4>
                  <p className="home-message-role">{item.role}</p>
                </div>
              </div>

            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeMessage;